import { render } from "./DeModal.vue?vue&type=template&id=6342eb22"
import script from "./DeModal.vue?vue&type=script&lang=js"
export * from "./DeModal.vue?vue&type=script&lang=js"

import exportComponent from "/media/doevent/Data/doevent/project/pmb/db/de-db-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__